module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-form",
    class: {
      focus: _vm.focus
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    ref: "input",
    staticClass: "search-box inner-x",
    attrs: {
      "type": "text",
      "placeholder": _vm.searchState.placeHolder
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "focus": _vm.toggleFocus,
      "blur": _vm.toggleFocus,
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.handleSearch(_vm.keyword)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.keyword) ? _c('svg-icon', {
    staticClass: "svg-icon close",
    attrs: {
      "name": "close"
    },
    on: {
      "click": _vm.handleClear
    }
  }) : _c('svg-icon', {
    staticClass: "svg-icon do-search",
    attrs: {
      "name": "search"
    },
    on: {
      "click": function($event) {
        _vm.handleSearch(_vm.keyword)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-dea80850"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchBox.vue
// module id = 106
// module chunks = 0